import { gettext } from '@eb/i18n';

import {
    // bucket keys
    FOLLOWED_PROFILES,
    ORGANIZERS_TO_FOLLOW,
    PRIMARY_BUCKET,
    SECONDARY_BUCKET,
    BEST_OF_CITY_EVENTS,
    LIKED_EVENTS,
    RECOMMENDED_EVENTS,

    // icons
    HEART_ICON,
    USER_ICON,
    FRIENDS_ICON,

    // tlds
    TLD_UNITED_STATES,
    TLD_UNITED_KINGDOM,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_IRELAND,
    TLD_NEW_ZEALAND,

    // languages
    LANGUAGE_AUSTRALIA,
    LANGUAGE_CANADA,
    LANGUAGE_UNITED_KINGDOM,
    LANGUAGE_UNITED_STATES,
    LANGUAGE_IRELAND,
    LANGUAGE_NEW_ZEALAND,

    // collections
    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
    CONNECT_THROUGH_ONLINE_EVENTS,
    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
    QA_TEST_BEST_HALLOWEEN_PARTIES_IN_WASHINGTON,
    QA_TEST_MOCKED_COLLECTION_FOR_TESTING,
    QA_TEST_MOCKED_COLLECTION_FOR_TESTING2,
    ENTERTAIMENT_TONIGHT,
    BLACK_HISTORY_AND_BEYOND,
    FESTIVE_EVENTS_UK_AND_IE,
    ONLINE_THANKSGIVING_COOKING,
    BEST_EVENTS_TO_EXPERIENCE_IN_BRISBANE,
    BEST_EVENTS_TO_EXPERIENCE_IN_PERTH,
    BEST_EVENTS_TO_EXPERIENCE_IN_AUCKLAND,
    BEST_UK_AND_IRELAND_EVENTS_URL,
    HOLIDAY_EVENTS_CHRISTMAS_HANUKKAH_KWANZAA,
    VIRTUAL_NEW_YEAR_EVENTS_2020,
    TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
    FEEL_THE_LOVE_UK_IE,
    VIRTUAL_VALENTINE_US_CA,
    BLACK_HISTORY_MONTH_US_CA,
    WOMENS_DAY_US_UK_IE,
    EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
    BEST_EVENTS_TO_EXPERIENCE_IN_MELBOURNE,
    BEST_EVENTS_TO_EXPERIENCE_IN_SYDNEY,
    UK_FESTIVALS_2021,
    STOP_ASIAN_HATE_US,
    PARK_UP_UK,
    ALL_YOUR_FAVES_UK_IE,
    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
    LOS_ANGELES_EVENT_CALENDAR_US,
    SAN_FRANCISCO_EVENT_CALENDAR_US,
    LONDON_EVENT_CALENDAR_UK,
    EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
    NEW_YORK_CITY_EVENT_CALENDAR,
    CHICAGO_CITY_EVENT_CALENDAR,
    WASHINGTON_DC_CITY_EVENT_CALENDAR,
    MUSIC_FESTIVAL_CALENDAR,
    TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES,
    HALLOWEEN_UK_IE,
} from './constants';

import { GRID_TYPE } from '@eb/eds-media-card-content';

import {
    MUSIC_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    CHARITY_EVENTBRITE_CATEGORY,
    CURRENT_FUTURE,
    DATES_MAPPING,
    PRICE_MAPPING,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING,
} from './index';

export const ALL_TAB = 'all';
export const THIS_WEEKEND_TAB = 'this_weekend';
export const FREE_TAB = 'free';
export const FOR_YOU = 'for_you';
export const MUSIC_TAB = 'music';
export const FOOD_TAB = 'food';
export const CHARITY_TAB = 'charity';
export const SEASONAL_TAB = 'seasonal';
export const TODAY_TAB = 'today';
export const ONLINE_TAB = 'online';

const MUSIC_TAB_NAME = EVENTBRITE_CATEGORY_MAPPING[MUSIC_EVENTBRITE_CATEGORY];
const MUSIC_TAB_NAME_LOWER =
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[MUSIC_EVENTBRITE_CATEGORY];

const FOOD_TAB_NAME =
    EVENTBRITE_CATEGORY_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY];
const FOOD_TAB_NAME_LOWER =
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY];

const CHARITY_TAB_NAME =
    EVENTBRITE_CATEGORY_MAPPING[CHARITY_EVENTBRITE_CATEGORY];
const CHARITY_TAB_NAME_LOWER =
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[CHARITY_EVENTBRITE_CATEGORY];

export const FEED_TABS = [
    ALL_TAB,
    FOR_YOU,
    ONLINE_TAB,
    TODAY_TAB,
    THIS_WEEKEND_TAB,
    `${SEASONAL_TAB}${'_0'}`,
    `${SEASONAL_TAB}${'_1'}`,
    `${SEASONAL_TAB}${'_2'}`,
    `${SEASONAL_TAB}${'_3'}`,
    `${SEASONAL_TAB}${'_4'}`,
    FREE_TAB,
    MUSIC_TAB,
    FOOD_TAB,
    CHARITY_TAB,
];

// Order in which collections should be shown on the carrousel
export const PRIORITY_COLLECTIONS = [
    QA_TEST_BEST_HALLOWEEN_PARTIES_IN_WASHINGTON,
    NEW_YORK_CITY_EVENT_CALENDAR,
    CHICAGO_CITY_EVENT_CALENDAR,
    WASHINGTON_DC_CITY_EVENT_CALENDAR,
    LOS_ANGELES_EVENT_CALENDAR_US,
    SAN_FRANCISCO_EVENT_CALENDAR_US,
    LONDON_EVENT_CALENDAR_UK,
    MUSIC_FESTIVAL_CALENDAR,
];

export const TABS_CONFIG = {
    [ALL_TAB]: {
        tabKeyLabel: 'All',
        name: gettext('All'),
        eventSearch: {
            dates: [CURRENT_FUTURE],
        },
        collections: {
            [TLD_UNITED_STATES]: {
                [LANGUAGE_UNITED_STATES]: [
                    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
                    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
                    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
                    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
                    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
                    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
                    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
                    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
                    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
                    QA_TEST_BEST_HALLOWEEN_PARTIES_IN_WASHINGTON,
                    QA_TEST_MOCKED_COLLECTION_FOR_TESTING,
                    QA_TEST_MOCKED_COLLECTION_FOR_TESTING2,
                    ENTERTAIMENT_TONIGHT,
                    ONLINE_THANKSGIVING_COOKING,
                    HOLIDAY_EVENTS_CHRISTMAS_HANUKKAH_KWANZAA,
                    VIRTUAL_NEW_YEAR_EVENTS_2020,
                    TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
                    VIRTUAL_VALENTINE_US_CA,
                    BLACK_HISTORY_MONTH_US_CA,
                    EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
                    STOP_ASIAN_HATE_US,
                    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
                    LOS_ANGELES_EVENT_CALENDAR_US,
                    SAN_FRANCISCO_EVENT_CALENDAR_US,
                    EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
                    NEW_YORK_CITY_EVENT_CALENDAR,
                    CHICAGO_CITY_EVENT_CALENDAR,
                    WASHINGTON_DC_CITY_EVENT_CALENDAR,
                    MUSIC_FESTIVAL_CALENDAR,
                ],
            },
            [TLD_CANADA]: {
                [LANGUAGE_CANADA]: [
                    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
                    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
                    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
                    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
                    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
                    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
                    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
                    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
                    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
                    QA_TEST_BEST_HALLOWEEN_PARTIES_IN_WASHINGTON,
                    ENTERTAIMENT_TONIGHT,
                    TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
                    VIRTUAL_VALENTINE_US_CA,
                    BLACK_HISTORY_MONTH_US_CA,
                    EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
                    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
                    EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
                ],
            },
            [TLD_UNITED_KINGDOM]: {
                [LANGUAGE_UNITED_KINGDOM]: [
                    BLACK_HISTORY_AND_BEYOND,
                    FESTIVE_EVENTS_UK_AND_IE,
                    BEST_UK_AND_IRELAND_EVENTS_URL,
                    TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
                    FEEL_THE_LOVE_UK_IE,
                    UK_FESTIVALS_2021,
                    PARK_UP_UK,
                    ALL_YOUR_FAVES_UK_IE,
                    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
                    LONDON_EVENT_CALENDAR_UK,
                    EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
                ],
            },
            [TLD_IRELAND]: {
                [LANGUAGE_IRELAND]: [
                    FESTIVE_EVENTS_UK_AND_IE,
                    BEST_UK_AND_IRELAND_EVENTS_URL,
                    TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY,
                    FEEL_THE_LOVE_UK_IE,
                    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
                    EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE,
                ],
            },
            [TLD_AUSTRALIA]: {
                [LANGUAGE_AUSTRALIA]: [
                    BEST_EVENTS_TO_EXPERIENCE_IN_BRISBANE,
                    BEST_EVENTS_TO_EXPERIENCE_IN_PERTH,
                    CONNECT_THROUGH_ONLINE_EVENTS,
                    EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU,
                    BEST_EVENTS_TO_EXPERIENCE_IN_MELBOURNE,
                    BEST_EVENTS_TO_EXPERIENCE_IN_SYDNEY,
                    ALL_YOUR_FAVES_UK_IE,
                    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
                    TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES,
                ],
            },
            [TLD_NEW_ZEALAND]: {
                [LANGUAGE_NEW_ZEALAND]: [
                    BEST_EVENTS_TO_EXPERIENCE_IN_AUCKLAND,
                    VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ,
                    TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES,
                ],
            },
        },
        feedConfig: {
            [BEST_OF_CITY_EVENTS]: {
                order: 1,
                propsOverwrite: {
                    name: gettext("Editor's picks"),
                    subtitle: {
                        lazyIncludeLocation: (location) =>
                            gettext(
                                "Discover %(location)s's best experiences, hand-picked by our experts.",
                                { location },
                            ),
                    },
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                ],
                overwrite: {
                    props: {
                        layout: {
                            desktop: {
                                events: {
                                    bucketClassNames:
                                        'premium-events-bucket__content eds-l-pad-bot-8',
                                    layout: {
                                        default: {
                                            containerClasses: [
                                                'feed__card-cell premium-card',
                                            ],
                                        },
                                    },
                                },
                            },
                            mobile: {
                                events: {
                                    bucketClassNames:
                                        'premium-events-bucket__content eds-l-pad-bot-8',
                                    layout: {
                                        default: {
                                            containerClasses: [
                                                'feed__card-cell premium-card',
                                            ],
                                        },
                                    },
                                    propsOverwrite: {
                                        default: {
                                            type: GRID_TYPE,
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            [PRIMARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: {
                        lazyIncludeLocation: (location) =>
                            gettext('Events in %(location)s', { location }),
                    },
                },
                shouldShowOnboardingCard: true,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 5,
                propsOverwrite: {
                    name: gettext('More events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [FOR_YOU]: {
        tabKeyLabel: FOR_YOU,
        name: gettext('For you'),
        feedConfig: {
            [LIKED_EVENTS]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('My liked events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                        },
                        config: {
                            title: gettext('Like your favorites events'),
                            iconType: HEART_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'Get better recomendations and see more events you´ll love',
                            ),
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                        },
                        config: {
                            title: gettext(
                                'Discover the best events, picked just for you',
                            ),
                            iconType: USER_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'Keep track of your liked events and see events from your favorite organizers when you log in',
                            ),
                            primaryText: gettext('Log In'),
                            primaryLink: '/login/?referrer=%2F',
                        },
                    },
                ],
            },
            [FOLLOWED_PROFILES]: {
                order: 1,
                propsOverwrite: {
                    name: gettext('From organizers you follow'),
                },
                shouldShowOnboardingCard: false,
                shouldShowEmptyState: true,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                        },
                        config: {
                            title: gettext('Follow your favorites organizers'),
                            iconType: FRIENDS_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'See their latest events here',
                            ),
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
            [RECOMMENDED_EVENTS]: {
                order: 0,
                propsOverwrite: {
                    name: gettext('Recommended events'),
                },
                shouldShowOnboardingCard: false,
                shouldShowEmptyState: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                        },
                        config: {
                            title: gettext('Recommended events'),
                            iconType: FRIENDS_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'See their latest events here',
                            ),
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
            // [ORGANIZERS_TO_FOLLOW]: {
            //     order: 3,
            //     propsOverwrite: {
            //         name: gettext('Organizers to follow'),
            //     },
            //     shouldShowOnboardingCard: false,
            //     layout: {
            //         desktop: {
            //             events: {
            //                 bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
            //             },
            //         },
            //         mobile: {
            //             events: {
            //                 bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
            //             },
            //         },
            //     },
            // },
        },
    },
    [ONLINE_TAB]: {
        tabKeyLabel: 'Online',
        name: gettext('Online'),
        eventSearch: {
            online_events_only: true,
            places: [],
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: { name: '' },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('More online events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [THIS_WEEKEND_TAB]: {
        tabKeyLabel: 'ThisWeekend',
        name: DATES_MAPPING[THIS_WEEKEND_TAB],
        eventSearch: {
            dates: [CURRENT_FUTURE, 'this_weekend'],
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More events this weekend'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [FREE_TAB]: {
        tabKeyLabel: 'Free',
        name: PRICE_MAPPING[FREE_TAB],
        eventSearch: {
            dates: [CURRENT_FUTURE],
            price: FREE_TAB,
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('More free events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [MUSIC_TAB]: {
        tabKeyLabel: 'Music',
        name: MUSIC_TAB_NAME,
        shouldShowOnboardingCard: false,
        eventSearch: {
            dates: [CURRENT_FUTURE],
            tags: MUSIC_EVENTBRITE_CATEGORY,
        },
        follow: [MUSIC_EVENTBRITE_CATEGORY],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {
                        tabName: MUSIC_TAB_NAME_LOWER,
                    }),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [FOOD_TAB]: {
        tabKeyLabel: 'FoodAndDrink',
        name: FOOD_TAB_NAME,
        eventSearch: {
            dates: [CURRENT_FUTURE],
            tags: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        },
        follow: [FOOD_AND_DRINK_EVENTBRITE_CATEGORY],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {
                        tabName: FOOD_TAB_NAME_LOWER,
                    }),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [CHARITY_TAB]: {
        tabKeyLabel: 'Charity',
        name: CHARITY_TAB_NAME,
        eventSearch: {
            dates: [CURRENT_FUTURE],
            tags: CHARITY_EVENTBRITE_CATEGORY,
        },
        follow: [CHARITY_EVENTBRITE_CATEGORY],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                orderAfter: [ORGANIZERS_TO_FOLLOW],
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {
                        tabName: CHARITY_TAB_NAME_LOWER,
                    }),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [TODAY_TAB]: {
        tabKeyLabel: 'Today',
        name: DATES_MAPPING[TODAY_TAB],
        eventSearch: {
            dates: [CURRENT_FUTURE, 'today'],
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('More events today'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
};
